import { render, staticRenderFns } from "./course-edit.vue?vue&type=template&id=3b9dac22&scoped=true"
import script from "./course-edit.vue?vue&type=script&lang=js"
export * from "./course-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9dac22",
  null
  
)

export default component.exports